import analytics from './components/analytics';
import chapters from './components/chapters';
import appRouting from './components/core/appRouting';
import menu from './components/menu';
import shutter from './helpers/shutter';

import './components/cookieConsent/cookies.css';
import './index.css';

/**
 * Dynamic import Swiper css keep the core lean.
 *
 * [todo]: Move to component import and check the output build size
 *
 * Need more styles? https://swiperjs.com/swiper-api
 */
const loadSwiperCss = async () => {
    try {
        await import('swiper/css');
    } catch {
        // Error loading Swiper CSS
    }
};

/**
 * Initialize the main core functionality and web workers.
 */
async function init() {
    loadSwiperCss();

    menu.init();
    chapters.init();
    shutter.init();
    appRouting.init();
    analytics.init();
}

init();
